import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2 } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { useMantineTheme } from '@mantine/core';
import { MultiSelect as MultiSelect$1 } from './MultiSelect.js';
import { Icon } from '../../Icon/Icon.js';
import { mergeClassNames, GUI_GLOBAL_CLASS, GUI_COMP_CSS_VARIABLE_CLASS } from '../../../utils/index.js';
import { useMultiSelectStyle } from './GateMultiSelect.style.js';
import { useSelectStyle } from '../GateSelect.style.js';
import { Checkbox } from '../../Checkbox/Checkbox.js';

var _excluded = ["label", "onRemove", "disabled", "readOnly", "classNames"],
  _excluded2 = ["label", "selected"],
  _excluded3 = ["styles", "className", "classNames", "size", "type", "noDefaultIcon", "breakpoints", "applyColorVariable", "invalid", "isH5MappingAppStyle"];
function Value(_ref) {
  var label = _ref.label,
    onRemove = _ref.onRemove,
    disabled = _ref.disabled,
    readOnly = _ref.readOnly;
    _ref.classNames;
    var others = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React__default.createElement("div", _objectSpread2({}, others), label, !disabled && !readOnly && ( /*#__PURE__*/React__default.createElement(Icon, {
    color: "var(--gui-color-icon-3)",
    styles: {
      root: {
        marginLeft: '2px'
      }
    },
    size: 12,
    onMouseDown: onRemove
  }, /*#__PURE__*/React__default.createElement("svg", {
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M2.5 9.5L6 6M9.5 2.5L6 6M6 6L9.5 9.5M6 6L2.5 2.5",
    stroke: "currentColor",
    strokeWidth: "1.2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
var SelectItem = /*#__PURE__*/forwardRef(function (_ref2, ref) {
  var label = _ref2.label,
    selected = _ref2.selected,
    other = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/React__default.createElement("div", _objectSpread2({
    ref: ref
  }, other), /*#__PURE__*/React__default.createElement(Checkbox, {
    size: 16,
    checked: selected,
    styles: {
      root: {
        marginRight: '8px'
      }
    }
  }), /*#__PURE__*/React__default.createElement("span", {
    style: {
      color: 'var(--gui-color-text-1)'
    }
  }, label));
});
var MultiSelect = /*#__PURE__*/forwardRef(function (props, ref) {
  var theme = useMantineTheme();
  var _props$styles = props.styles,
    styles = _props$styles === void 0 ? {} : _props$styles,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    classNames = props.classNames,
    _props$size = props.size,
    size = _props$size === void 0 ? 'md' : _props$size,
    _props$type = props.type,
    type = _props$type === void 0 ? 'outlined' : _props$type,
    noDefaultIcon = props.noDefaultIcon,
    _props$breakpoints = props.breakpoints,
    breakpoints = _props$breakpoints === void 0 ? [] : _props$breakpoints,
    _props$applyColorVari = props.applyColorVariable,
    applyColorVariable = _props$applyColorVari === void 0 ? false : _props$applyColorVari,
    invalid = props.invalid,
    _props$isH5MappingApp = props.isH5MappingAppStyle,
    isH5MappingAppStyle = _props$isH5MappingApp === void 0 ? theme.other.isH5MappingAppStyle : _props$isH5MappingApp,
    restProps = _objectWithoutProperties(props, _excluded3);
  var hasLeft = !!restProps.icon;
  var _useSelectStyle = useSelectStyle({
      size: size,
      isH5MappingAppStyle: isH5MappingAppStyle,
      hasLeft: hasLeft,
      breakpoints: [],
      type: type
    }, {
      name: 'GateSelect'
    }),
    SelectStyleClasses = _useSelectStyle.classes;
  var _useMultiSelectStyle = useMultiSelectStyle({
      size: size,
      breakpoints: breakpoints
    }, {
      styles: styles,
      classNames: mergeClassNames(SelectStyleClasses, classNames || {}),
      name: 'GateMultiSelect'
    }),
    cx = _useMultiSelectStyle.cx,
    classes = _useMultiSelectStyle.classes;
  var showDefaultIcon = !noDefaultIcon;
  if (hasLeft) {
    restProps.icon = React__default.Children.map(restProps.icon, function (child) {
      if ( /*#__PURE__*/React__default.isValidElement(child) && child.type === Icon) {
        return /*#__PURE__*/React__default.cloneElement(child, {
          className: classes.iconElement + ' ' + child.props.className || ''
        });
      }
      return child;
    });
  }
  restProps.rightSection = /*#__PURE__*/React__default.createElement(React__default.Fragment, null, restProps.rightSection, showDefaultIcon && ( /*#__PURE__*/React__default.createElement("svg", {
    className: classes.rightSectionIcon,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("path", {
    d: "M3.40039 5.69995L8.00039 10.3L12.6004 5.69995",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
  return /*#__PURE__*/React__default.createElement(MultiSelect$1, _objectSpread2({
    inputWrapperOrder: ['label', 'input', 'description', 'error'],
    ref: ref,
    dir: theme.dir,
    error: invalid,
    className: cx(className, GUI_GLOBAL_CLASS, applyColorVariable ? GUI_COMP_CSS_VARIABLE_CLASS : undefined),
    disableSelectedItemFiltering: true,
    classNames: classes,
    valueComponent: Value,
    itemComponent: SelectItem
  }, restProps), props.children);
});

export { MultiSelect };
//# sourceMappingURL=GateMultiSelect.js.map
